<script>
    export let episode;
</script>

<svelte:head>
    <title>{episode.title + " | "} The Conspiracy Club</title>
    <meta property="og:title" content="The Conspiracy Club" /><meta
        property="og:description"
        content={episode.info}
    /><meta
        property="og:image"
        content={episode.image}
    /><meta property="og:url" content={"" + episode.link} />
</svelte:head>
